<div
  *ngIf="orders.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header">
  <table
    mat-table
    [dataSource]="orders"
    class="sp-width__full">
    <ng-container matColumnDef="order_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ORDER_ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <app-shared-id
          [content]="order.order_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="last_status_change">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.LAST_STATUS_CHANGE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ getLastOrderStatusChange(order.last_status_change) | translate }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="last_status_change_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.LAST_STATUS_CHANGE_AT_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.last_status_change_at ? (order.last_status_change_at | date : 'short') : '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="liquidated_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.LIQUIDATION_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ order.liquidated_at ? 'OK' : 'KO' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="qinetic">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">Qinetic ID</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div class="sp-row__align">
          <app-shared-id
            *ngIf="order.position_id"
            [content]="order.position_id"
            [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover sp-color__green sp-text__bold'"
            [is_shrinked_id]="false"
            (content_click)="onQineticClick(order)"></app-shared-id>

          <button
            *ngIf="!order.position_id && order.position_error"
            (click)="onPositionErrorClick(order); $event.stopPropagation()"
            mat-icon-button>
            <mat-icon class="sp-color__warn"> bug_report </mat-icon>
          </button>

          <span *ngIf="!order.position_id && !order.position_error"> - </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="is_looked_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.IS_LOOKED_AT_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div>
          <span>{{ order.is_looked_at ? ('GENERAL.YES_LABEL' | translate) : ('GENERAL.NO_LABEL' | translate) }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="liquidation_stoplight">
      <th
        mat-header-cell
        *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let order">
        <div
          class="sp-circle__xs"
          [ngClass]="order.liquidated_at ? 'sp-background__status-50' : 'sp-background__status-400'"></div>
      </td>
    </ng-container>

    <ng-container matColumnDef="BD1">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">BD1</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.bd1_result"
          (click)="onDecidoClick(order, order.bd1_evaluation_id); $event.stopPropagation()"
          [ngClass]="getEvaluationClass(order.bd1_result)"
          class="sp-text__ellipsized sp-text__hover sp-text__bold">
          {{ order.bd1_result | uppercase }}
        </span>
        <app-shared-id
          *ngIf="!order.bd1_result && order.bd1_evaluation_id"
          (click)="onDecidoClick(order, order.bd1_evaluation_id); $event.stopPropagation()"
          [content]="order.bd1_evaluation_id"
          [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover'"
          [is_shrinked_id]="true"></app-shared-id>
        <span *ngIf="!order.bd1_result && !order.bd1_evaluation_id"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="BD2">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">BD2</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.bd2_result"
          (click)="onDecidoClick(order, order.bd2_evaluation_id); $event.stopPropagation()"
          [ngClass]="getEvaluationClass(order.bd2_result)"
          class="sp-text__ellipsized sp-text__hover sp-text__bold">
          {{ order.bd2_result | uppercase }}
        </span>
        <app-shared-id
          *ngIf="!order.bd2_result && order.bd2_evaluation_id"
          (click)="onDecidoClick(order, order.bd2_evaluation_id); $event.stopPropagation()"
          [content]="order.bd2_evaluation_id"
          [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover'"
          [is_shrinked_id]="true"></app-shared-id>
        <span *ngIf="!order.bd2_result && !order.bd2_evaluation_id"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="BD5">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">BD5</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.bd5_result"
          (click)="onDecidoClick(order, order.bd5_evaluation_id); $event.stopPropagation()"
          [ngClass]="getEvaluationClass(order.bd5_result)"
          class="sp-text__ellipsized sp-text__hover sp-text__bold">
          {{ order.bd5_result | uppercase }}
        </span>
        <app-shared-id
          *ngIf="!order.bd5_result && order.bd5_evaluation_id"
          (click)="onDecidoClick(order, order.bd5_evaluation_id); $event.stopPropagation()"
          [content]="order.bd5_evaluation_id"
          [content_class]="'sp-color__primary sp-cursor__pointer sp-text__hover'"
          [is_shrinked_id]="true"></app-shared-id>
        <span *ngIf="!order.bd5_result && !order.bd5_evaluation_id"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div
          [ngClass]="getOrderStatusClass(order.status)"
          class="sp-order__status-radius sp-row__center sp-padding__horiz">
          <span class="sp-text__ellipsized sp-text__center">{{
            getOrderStatusLabel(order.status || '-') | translate | lowercase
          }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="store">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'GENERAL.STORE_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div class="sp-row__align">
          <app-shared-store-logo
            size="m"
            [current_store_logo]="order?.store_logo"></app-shared-store-logo>
          <span class="sp-text__ellipsized sp-margin__left">
            <b> {{ order.store_name || '-' }} </b>
          </span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="seller_email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.OWNER_LINK_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-color__primary sp-text__ellipsized">
          {{ order.seller_email || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="buyer">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.BUYER_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.buyer_firstname"
          class="sp-text__ellipsized">
          <b>
            {{ getFullName(order).length > 30 ? (getFullName(order) | slice : 0 : 30) + '...' : getFullName(order) }}
          </b>
        </span>

        <span
          *ngIf="!order.buyer_firstname && order.buyer_phone"
          class="sp-text__ellipsized">
          <b>{{ order.buyer_phone.prefix || '-' }} {{ order.buyer_phone.value || '' }}</b>
        </span>

        <span *ngIf="!order.buyer_firstname && !order.buyer_phone">-</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="channel">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.CHANNEL_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <app-shared-order-channel [order]="order"></app-shared-order-channel>
      </td>
    </ng-container>

    <ng-container matColumnDef="origin">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.ORIGIN_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <app-shared-order-origin [order]="order"></app-shared-order-origin>
      </td>
    </ng-container>

    <ng-container matColumnDef="tax_deduction">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.TAX_DEDUCTION_SHORT_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <p class="sp-text__ellipsized sp-text__center">
          {{ order.tax_deduction ? ('GENERAL.YES_LABEL' | translate) : ('GENERAL.NO_LABEL' | translate) }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="tax_deduction_type">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'COMPANIES.TAX_DEDUCTION_TYPE_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.tax_deduction?.tax_deduction_type || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="ext_order_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.EXT_ORDER_ID_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.ext_order_id || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tax_deduction_invoice_number">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.TAX_DEDUCTION_INVOICE_NUMBER_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.tax_deduction?.tax_deduction_invoice_number || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="tax_deduction_invoice_date">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.TAX_DEDUCTION_INVOICE_DATE_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.tax_deduction?.tax_deduction_invoice_date"
          class="sp-text__ellipsized">
          {{ order.tax_deduction?.tax_deduction_invoice_date | date : 'dd/MM/yyyy' }}
        </span>

        <span *ngIf="!order.tax_deduction?.tax_deduction_invoice_date"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="ready_for_liquidation_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.APPROVED_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.ready_for_liquidation_at ? ('GENERAL.YES_LABEL' | translate) : ('GENERAL.NO_LABEL' | translate) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="owner">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.OWNER_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.seller_email || '-' }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.AMOUNT_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <button
          (click)="onOrderAmountClick(order); $event.stopPropagation()"
          mat-icon-button>
          <mat-icon class="material-symbols-outlined sp-color__primary"> visibility </mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="instalments">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.INSTALMENTS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <p class="sp-text__ellipsized sp-text__center">
          {{ order.summary.total || '-' }}
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="payment_source">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.PAY_METHOD_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <ng-container *ngIf="order.buyer_qinetic_payment_source; else card">
          <div class="sp-row__align">
            <span>sdd</span>
            <img
              *ngIf="getPaymentMethodLogo(order)"
              class="sp-table__payment_methods_icon sp-padding"
              [src]="getPaymentMethodLogo(order)"
              alt="sepa" />
          </div>
        </ng-container>

        <ng-template #card>
          <ng-container *ngIf="order.buyer_stripe_payment_source?.stripe_card">
            <div class="sp-row__align">
              <span>
                {{ order.buyer_stripe_payment_source?.stripe_card.funding }}
              </span>
              <img
                class="sp-table__payment_methods_icon sp-padding"
                [src]="getPaymentMethodLogo(order)"
                alt="{{ order.buyer_stripe_payment_source?.stripe_card.brand }}" />
            </div>
          </ng-container>
        </ng-template>

        <span *ngIf="!order.buyer_qinetic_payment_source && !order.buyer_stripe_payment_source?.stripe_card">-</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="fee">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.FEE_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.amount?.sp_total_fee / 100 || 0 | number : '0.2-2' }}
          {{ getCurrencyLabel(order) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="net">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.NET_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span class="sp-text__ellipsized">
          {{ order.amount?.net / 100 || 0 | number : '0.2-2' }}
          {{ getCurrencyLabel(order) }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="merchant_refund">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.MERCHANT_REFUND_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div [ngSwitch]="order.vban_status">
          <span *ngSwitchCase="'pending'">
            {{ 'VBAN.PENDING_LABEL' | translate }}
          </span>
          <span *ngSwitchCase="'succeeded'">
            {{ 'VBAN.SUCCEEDED_LABEL' | translate }}
          </span>
          <span *ngSwitchCase="'partially_funded'">
            {{ 'VBAN.PARTIALLY_FUNDED_LABEL' | translate }}
          </span>
          <span *ngSwitchDefault>-</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="agreement">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'GENERAL.AGREEMENT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let store">
        <span class="sp-color__primary sp-text__ellipsized"> {{ store.agreement || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="payment_link">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span>{{ 'ORDERS.PAYMENT_LINK_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div class="sp-row__align">
          <mat-icon
            (click)="onCopyClick(getPaymentLink(order)); $event.stopPropagation()"
            [matTooltip]="'GENERAL.COPY_CTA' | translate"
            class="sp-color__primary sp-cursor__pointer sp-margin__left sp-icon__s">
            content_copy
          </mat-icon>
          <a
            [href]="getPaymentLink(order)"
            target="_blank"
            class="sp-margin__quarter-left">
            {{ getPaymentLink(order).substring(0, 25) }}...
          </a>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.CREATED_AT_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.created_at"
          class="sp-text__ellipsized">
          {{ order.created_at | date : 'short' }}
        </span>

        <span *ngIf="!order.created_at"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="completed_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.COMPLETED_AT_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.running_at"
          class="sp-text__ellipsized">
          {{ order.running_at | date : 'short' }}
        </span>

        <span
          *ngIf="order.canceled_at"
          class="sp-text__ellipsized">
          {{ order.canceled_at | date : 'short' }}
        </span>

        <span *ngIf="!order.running_at && !order.canceled_at"> - </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="pre_authorization_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.PRE_AUTH_DATE_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <span
          *ngIf="order.pre_authorization_at"
          class="sp-text__ellipsized">
          {{ order.pre_authorization_at | date : 'short' }}
        </span>

        <span
          *ngIf="!order.pre_authorization_at"
          class="sp-text__ellipsized">
          -
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">{{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let order">
        <div class="sp-row__align">
          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>

          <button
            (click)="$event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [matTooltip]="'Menu' | translate"
            [mat-menu-trigger-for]="orders_actions_menu">
            <mat-icon> more_horiz </mat-icon>
          </button>

          <mat-menu #orders_actions_menu="matMenu">
            <button
              (click)="onQineticReloadClick(order); $event.stopPropagation()"
              [disabled]="
                ![refunded_order_status, running_order_status, canceled_order_status].includes(order.status) ||
                order.position_id
              "
              class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> reply </mat-icon>
              <span> {{ 'ORDERS.QINETIC_RETRY_CTA' | translate }} </span>
            </button>

            <button
              (click)="onRequestsClick(order); $event.stopPropagation()"
              class="sp-padding__vert"
              mat-menu-item>
              <mat-icon class="material-symbols-outlined sp-color__accent"> list </mat-icon>
              <span> {{ 'GENERAL.SEE_REQUESTS_CTA' | translate }} </span>
            </button>
          </mat-menu>

          <!--<button
            (click)="onQineticReloadClick(order); $event.stopPropagation()"
            [disabled]="
              ![refunded_order_status, running_order_status, canceled_order_status].includes(order.status) ||
              order.position_id
            "
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent"
            [matTooltip]="'ORDERS.QINETIC_RETRY_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> reply </mat-icon>
          </button>

          <button
            (click)="onRequestsClick(order); $event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [matTooltip]="'GENERAL.SEE_REQUESTS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> list </mat-icon>
          </button>-->
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: displayed_columns"
      class="sp-cursor__pointer"
      (click)="onDetailsClick(row)"></tr>
  </table>
</div>
